import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { Sidebar } from '@/components/dashboard/sidebar'
import { MobileHeader } from '@/components/dashboard/mobile-header'
import { RouteProgress } from '@/components/dashboard/route-progress'

export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col'>
            <a
                href='#main-content'
                className='sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[80] focus:rounded-lg focus:bg-card focus:px-4 focus:py-2 focus:text-sm focus:font-semibold focus:text-foreground focus:shadow-lg'
            >
                Skip to content
            </a>

            <RouteProgress />

            <aside
                aria-label='Sidebar'
                className='fixed inset-y-0 left-0 z-40 hidden w-64 border-r border-sidebar-border lg:block'
            >
                <Sidebar />
            </aside>

            <MobileHeader />

            <div className='flex flex-1 flex-col lg:pl-64'>
                <main
                    id='main-content'
                    tabIndex={-1}
                    className='mx-auto w-full max-w-[1440px] flex-1 px-4 py-6 outline-none sm:px-6 lg:px-8 lg:py-8'
                >
                    {children}
                </main>
            </div>
        </div>
    )
}
